// frontend/src/components/SupplierInfoBlock.js
import React from "react";

async function readCfg() {
  try {
    const r = await fetch("/api/config");
    return await r.json();
  } catch {
    const c = localStorage.getItem("supplier_cfg");
    return c ? JSON.parse(c) : {};
  }
}

export default function SupplierInfoBlock() {
  const [cfg, setCfg] = React.useState({});
  React.useEffect(() => { readCfg().then(setCfg); }, []);

  const {
    supplier_office = "",
    supplier_phone = "",
    supplier_manager = "",
    supplier_manager_mobile = "",
  } = cfg;

  return (
    <div className="supplier-info-grid">
      <div>{supplier_office}</div>
      <div>{supplier_phone}</div>
      <div>{supplier_manager}</div>
      <div>{supplier_manager_mobile}</div>
    </div>
  );
}
